import React from 'react';
import clsx from 'clsx';

import { Check } from './Check';
import { useLocalize } from '../../hooks';

type ProgressBarProps = {
  progressPercent: number;
  height?: string;
  color?: string;
  rounded?: boolean;
  showLabel?: boolean;
  className?: string;
  containerClassName?: string;
  label?: React.ReactNode | React.ReactElement | string;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  height = 'h-2',
  className = '',
  progressPercent,
  rounded = true,
  showLabel = true,
  containerClassName,
  color = 'bg-darkText',
  label,
}) => {
  const { t } = useLocalize();
  const completed = progressPercent >= 100;

  return (
    <div
      className={clsx('w-full flex', containerClassName ?? 'flex-col py-sm')}
    >
      <div
        className={clsx(
          'w-full flex relative',
          height,
          rounded && 'rounded-full',
          className
        )}
      >
        <div
          className={clsx(
            'transition-all duration-500 ease-in-out absolute top-0 left-0',
            height,
            completed ? 'bg-completed' : color,
            rounded && 'rounded-full'
          )}
          style={{ width: `${Math.min(100, Math.max(0, progressPercent))}%` }}
        ></div>
      </div>
      {showLabel &&
        (label ? (
          label
        ) : (
          <div className="text-md font-bold pt-xs inline-flex items-center gap-sm">
            {completed ? (
              <Check />
            ) : (
              `${Math.min(100, Math.max(0, progressPercent))}%`
            )}
            <span className="text-textSecondary text-tiny">
              {completed
                ? t('courses.item.completed')
                : t('courses.item.complete')}
            </span>
          </div>
        ))}
    </div>
  );
};
